/** GitHub-style relative time: "3 minutes ago", "yesterday", "Mar 14". */
export function relTime(input: string | Date | number): string {
  const t = typeof input === "string" || typeof input === "number" ? new Date(input) : input;
  const diff = (Date.now() - t.getTime()) / 1000;
  if (diff < 5) return "just now";
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 2) return "yesterday";
  if (diff < 86400 * 14) return `${Math.floor(diff / 86400)}d ago`;
  return t.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

/** Build duration: "1m 23s" or "47s". */
export function duration(ms: number | null | undefined): string {
  if (ms == null || ms < 0) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${s % 60}s`;
}

export function shortSha(sha: string, len = 7): string {
  return sha.slice(0, len);
}

export function formatBytes(n: number | null | undefined): string {
  if (n == null || n < 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 ** 3) return `${(n / 1024 ** 2).toFixed(1)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}
